<div class="container-fluid container-xxl gx-0 my-13">
    <div>
        <div class="col-md-8 mx-auto col-11 fs-md-15 fs-14">
            <h5 class="text-center fw-700">{{ 'REGULATIONS.title-1' | translate }}</h5>
            <h5 class="text-center fw-700">{{ 'REGULATIONS.title-2' | translate }}</h5>
            <h5 class="text-start fw-700 mt-10">{{ 'REGULATIONS.CHAPTER-1.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-1.SUB-CHAPTER-1.title' | translate }}
                    <a [routerLink]="['/'] | localize">{{ currentDomain }}.</a>
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-1.SUB-CHAPTER-2.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-1.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-2.title' | translate }}</h5>
            <p class="ms-3 mt-8">
                {{ 'REGULATIONS.CHAPTER-2.description' | translate }}
            </p>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-1.title' | translate"></p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-2.title' | translate"></p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3)' | translate }}</span>
                <p class="col-11">
                    <span [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-3.title' | translate"></span>
                    <a [routerLink]="['/'] | localize">{{ currentDomain }}</a
                    >;
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.4)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-4.title' | translate"></p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.5)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-5.title' | translate"></p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.6)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-6.title' | translate"></p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.7)' | translate }}</span>
                <p class="col-11" [innerHtml]="'REGULATIONS.CHAPTER-2.SUB-CHAPTER-7.title' | translate"></p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-3.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-1.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-2.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <div class="col-11">
                    <p>
                        {{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-1.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-2.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-3.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.d.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-4.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.e.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-5.title' | translate }}</p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.f.' | translate }}</span>
                        <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-3.SUB-SECTION-6.title' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.4.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-3.SUB-CHAPTER-4.title' | translate }}</p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-4.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-4.SUB-CHAPTER-1.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-4.SUB-CHAPTER-2.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-4.SUB-CHAPTER-3.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.4.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-4.SUB-CHAPTER-4.title' | translate }}</p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.5.' | translate }}</span>
                <p class="col-11">{{ 'REGULATIONS.CHAPTER-4.SUB-CHAPTER-5.title' | translate }}</p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-5.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <div class="col-11">
                    <p>
                        {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-2.title' | translate }}
                    </p>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.a.' | translate }}</span>
                        <p class="col-11">
                            {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-2.SUB-SECTION-1.title' | translate }}
                        </p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.b.' | translate }}</span>
                        <p class="col-11">
                            {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-2.SUB-SECTION-2.title' | translate }}
                        </p>
                    </div>
                    <div class="mt-2 ms-2 row">
                        <span class="col-1 text-end">{{ 'LETTERS.c.' | translate }}</span>
                        <p class="col-11">
                            {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-2.SUB-SECTION-3.title' | translate }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-5.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-6.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-6.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-6.SUB-CHAPTER-2.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-7.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-7.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-7.SUB-CHAPTER-2.title' | translate }}
                </p>
            </div>
            <h5 class="text-start fw-700 mt-8">{{ 'REGULATIONS.CHAPTER-8.title' | translate }}</h5>
            <div class="mt-8 row">
                <span class="col-1 text-end">{{ 'NUMBERS.1.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-8.SUB-CHAPTER-1.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.2.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-8.SUB-CHAPTER-2.title' | translate }}
                </p>
            </div>
            <div class="mt-2 row">
                <span class="col-1 text-end">{{ 'NUMBERS.3.' | translate }}</span>
                <p class="col-11">
                    {{ 'REGULATIONS.CHAPTER-8.SUB-CHAPTER-3.title' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
